import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import GoBackButton from 'components/button/GoBackButton';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import LoadingCard from 'components/loading/LoadingCard';
import ProductResource from './ProductResource';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import fetchResourceById from 'components/hoc/fetchResourceById';
import translate from 'components/hoc/translate';
import { SubmissionError } from 'redux-form';
import { connect } from 'react-redux';
import { fetchProduct } from 'store/actions/products/fetchProducts';
import { updateProductResource } from 'store/actions/products/resource/updateProductResource';
import utils from 'helpers/utils';

class ProductResourceContainer extends React.Component {
    handleSubmitForm = (values) => {
        const {
            data,
            history,
            id,
            dispatchForm,
            translate,
        } = this.props;

        return new Promise((resolve, reject) => {
            dispatchForm({
                onError: (error) => {
                    let formErrors = {
                        _error: false,
                    };

                    if (error.response.message === 'The id format is invalid.') {
                        formErrors.id = translate('forms.error.the-id-format-is-invalid');
                        formErrors._error = true;
                    }

                    if (formErrors._error) {
                        reject(new SubmissionError(formErrors));
                    }

                    resolve();
                },
                onSuccess: () => {
                    resolve(history.push(`/products/${ id }/show`));
                },
                id: id,
                values: utils.diffObjects(data.resource, values),
            });
        });
    }

    render() {
        const {
            data,
            form,
            id,
            resourceFetchFailed,
            resourceFetchLoading,
            translate,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const breadcrumbs = [
            {
                label: translate('resources.products.title'),
                link: '/products',
            },
            {
                label: data.title,
                link: `/products/${ id }/show`,
            },
            {
                label: translate('resources.products.actions.resource'),
            },
            {
                label: translate('actions.edit'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.products.pages.resource', { title: data.title }) } />

                    <Actions>
                        <GoBackButton url={ `/products/${ id }/show` } />

                        <ListButton url='/products' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <ProductResource
                            data={ data.resource }
                            form={ form }
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

ProductResourceContainer.defaultProps = {
    form: 'product_resource',
};

ProductResourceContainer.propTypes = {
    data: PropTypes.object,
    dispatchForm: PropTypes.func.isRequired,
    form: PropTypes.string,
    history: PropTypes.object,
    id: PropTypes.string,
    resource: PropTypes.string,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch,) => {
    return {
        fetch: (values) => {
            dispatch(fetchProduct(values));
        },
        dispatchForm: (values) => {
            dispatch(updateProductResource(values));
        },
    };
};

const enhance = compose(
    translate,
    connect(
        null,
        mapDispatchToProps,
    ),
    fetchResourceById({
        action: fetchProduct,
        resource: 'products',
    })
);

export default enhance(ProductResourceContainer);



// WEBPACK FOOTER //
// ./src/pages/products/resource/ProductResourceContainer.js